module.exports = __webpack_public_path__ + "img/CB_Hellborn Brute.9231ec3a.gif";